import { useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

import { fetchPage } from 'store/slices/pageSlice';
import { loadingStatus } from 'helpers/fetcher';

const PRIVACY_INFORMATION_ID = 3;

const PagePrivacy = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { data, status } = useSelector(state => state.page.page);
	const contentRef = useRef(null);

	useEffect(() => {
		dispatch(fetchPage({ id: PRIVACY_INFORMATION_ID }));
	}, [dispatch]);

	const processedDescription = useMemo(() => {
		if (!data?.description) return '';
		return data.description.replace(/text_error/gi, '').trim();
	}, [data?.description]);

	useEffect(() => {
		if (
			status === loadingStatus.SUCCEEDED &&
			data?.description &&
			contentRef.current
		) {
			const images = contentRef.current.querySelectorAll('img');
			images.forEach(img => {
				const handleError = e => {
					const target = e?.target || img;
					target.style.backgroundColor = '#d9d9d9';
					target.style.minHeight = '200px';
					target.style.display = 'block';
					target.style.borderRadius = '20px';
					target.alt = t('common.imageNotLoaded');
					target.onerror = null;
					target.src =
						"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E";
				};
				if (img.complete && img.naturalHeight === 0) {
					handleError({ target: img });
				} else {
					img.addEventListener('error', handleError);
				}
			});
		}
	}, [status, data?.description, t]);

	return (
		<div className='region news-detail-section'>
			<div className='news-detail-wrapper'>
				<div className='contact-breadcrumb' style={{ marginTop: '64px' }}>
					<a
						href='/'
						onClick={e => {
							e.preventDefault();
							navigate('/');
						}}
						className='breadcrumb-link'
					>
						{t('common.home')}
					</a>
					<span className='breadcrumb-separator breadcrumb-separator-active'></span>
					<span className='breadcrumb-current'>
						{t('footer.privacyPolicy')}
					</span>
				</div>

				{status === loadingStatus.SUCCEEDED && data ? (
					<>
						<h2
							className='news-detail-title'
							style={{ marginBottom: '24px' }}
						>
							{data.heading_title || t('footer.privacyPolicy')}
						</h2>

						{processedDescription && (
							<div
								ref={contentRef}
								className='news-detail-content'
								dangerouslySetInnerHTML={{ __html: processedDescription }}
							/>
						)}
					</>
				) : status === loadingStatus.LOADING ? (
					<>
						<Skeleton
							active
							paragraph={{ rows: 2 }}
							style={{ marginBottom: '24px' }}
						/>
						<Skeleton active paragraph={{ rows: 8 }} />
					</>
				) : (
					<div>{t('common.pageNotFound')}</div>
				)}
			</div>
		</div>
	);
};

export default PagePrivacy;
